var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38393 11.3333C2.72593 3.03001 8.60793 0.67468 13.3153 1.48268C13.5059 4.23468 12.1593 5.26468 9.59526 5.74068C10.0899 6.25801 10.9653 6.90935 10.8706 7.72335C10.8039 8.30201 10.4106 8.58668 9.62393 9.15468C7.89993 10.4 5.9026 11.1867 3.38393 11.3333Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38607 6.34908C7.56152 6.56232 7.53088 6.87742 7.31764 7.05287C5.56425 8.49551 3.16663 10.577 3.16663 14.6668C3.16663 14.9429 2.94277 15.1668 2.66663 15.1668C2.39048 15.1668 2.16663 14.9429 2.16663 14.6668C2.16663 10.0898 4.89967 7.74734 6.68228 6.28065C6.89552 6.1052 7.21062 6.13584 7.38607 6.34908Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack1);
export default __webpack_public_path__ + "static/media/Black-1.1448f0db6dd254bc87a5c1160134e2b2.svg";
export { ForwardRef as ReactComponent };